import { render, staticRenderFns } from "./FreeInfoSheet.vue?vue&type=template&id=50fe9dad&scoped=true"
import script from "./FreeInfoSheet.vue?vue&type=script&lang=js"
export * from "./FreeInfoSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe9dad",
  null
  
)

export default component.exports